import { apiHelper } from './api_helper';

export const TRANG_THAI_HOC_SINH_API_END_POINT = "dm_trangthaihocsinh";
export const trangThaiHocSinhApi = {
  SelectAll: () => apiHelper.get(`${TRANG_THAI_HOC_SINH_API_END_POINT}`),
  SelectAllCheckDangKy: (dm_coso_id) => apiHelper.get(`${TRANG_THAI_HOC_SINH_API_END_POINT}/check_dang_ky/${dm_coso_id}`),
  SelectByCoSo: (dm_coso_id) => apiHelper.get(`${TRANG_THAI_HOC_SINH_API_END_POINT}/select_by_coso/${dm_coso_id}`),
  Detail: (id) => apiHelper.get(`${TRANG_THAI_HOC_SINH_API_END_POINT}/${id}`),
  Insert: (data) => apiHelper.post(`${TRANG_THAI_HOC_SINH_API_END_POINT}`, data),
  InsertMultiple: (data) => apiHelper.post(`${TRANG_THAI_HOC_SINH_API_END_POINT}/insert-multiple`, data),
  Update: (data) => apiHelper.put(`${TRANG_THAI_HOC_SINH_API_END_POINT}`, data),
  UpdateThuTuAsync: (data) => apiHelper.put(`${TRANG_THAI_HOC_SINH_API_END_POINT}/update-thu-tu`, data),
  Delete: (id) => apiHelper.delete(`${TRANG_THAI_HOC_SINH_API_END_POINT}/${id}`),
}